import get from 'lodash/get';

const getShareCount = shares => {
  const facebookShares = get(shares, 'facebook', {});
  const { count = 0 } = facebookShares;
  return count;
};

export default getShareCount;
